import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  return (
    <nav className="navbar">
      <Link to="/" className="navbar-brand">
        <img src="/logo.svg" alt="#Paisa Pyara" className="brand-logo" />
        <span>#Paisa Pyara</span>
      </Link>
      <div className="navbar-links">
        <Link to="/" className="nav-link">Home</Link>
        <Link to="/blog" className="nav-link">Blog</Link>
        <a 
          href="https://www.incometax.gov.in" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="nav-link"
        >
          Income Tax Portal
        </a>
      </div>
    </nav>
  );
};

export default Navbar;

